/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";

import * as customerActions from "../../actions/customerActions";

import Loading from "../common/Loading";
import RequestNatureSelect from "../common/RequestNatureSelect";
import TagInput from "../common/TagInput";

import "./ProjectKeywordsList.scss";

const ProjectKeywordsList = ({
  data,
  loading,
  refetching,
  onPageChange,
  page,
  onProjectChange
}) => {
  const [expanded, setExpanded] = useState({});
  const [innerData, setInnerData] = useState([]);

  useEffect(() => {
    const allExpanded = {};
    data.result.forEach((row, index) => {
      allExpanded[index] = true;
    });
    setExpanded(allExpanded);
  }, [data]);

  useEffect(() => {
    if (data.result && data.result.length) {
      setInnerData(data.result);
    }
  }, [data]);

  const handleRowToggle = (rowIndex) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [rowIndex]: !prevExpanded[rowIndex]
    }));
  };

  const handleRequestNatureChange = (value, projectId, original) => {
    const newData = [...innerData];
    const customerIndex = newData.findIndex(
      (item) => item._id === original.customer
    );
    if (customerIndex > -1) {
      const projectIndex = newData[customerIndex].projects.findIndex(
        (item) => item._id === projectId
      );
      if (projectIndex > -1) {
        newData[customerIndex].projects[projectIndex].projectRequestNatures =
          value?.map((rn) => rn.value);
        setInnerData(newData);
        onProjectChange(original._id, {
          requestNatures: value?.map((rn) => rn.value),
          keywords: original.projectKeywords
        });
      }
    }
  };

  const handleKeywordsChange = (value, projectId, original) => {
    const newData = [...innerData];
    const customerIndex = newData.findIndex(
      (item) => item._id === original.customer
    );
    if (customerIndex > -1) {
      const projectIndex = newData[customerIndex].projects.findIndex(
        (item) => item._id === projectId
      );
      if (projectIndex > -1) {
        newData[customerIndex].projects[projectIndex].projectKeywords = value;
        setInnerData(newData);
        onProjectChange(original._id, {
          requestNatures: original.projectRequestNatures,
          keywords: value
        });
      }
    }
  };

  const columns = [
    {
      accessor: "name",
      Cell: ({ value }) => (
        <div style={{ background: "rgba(80, 172, 203, 0.2)", padding: 10 }}>
          <b>{value}</b>
        </div>
      )
    }
  ];

  const projectColumns = [
    { Header: "Project Name", accessor: "name", maxWidth: 250 },
    {
      Header: "Request Natures",
      accessor: "projectRequestNatures",
      maxWidth: 300,
      Cell: ({ original }) => (
        <RequestNatureSelect
          label=""
          name="request_nature"
          placeholder="Request Nature"
          value={
            original.projectRequestNatures?.map((rn) => ({
              label: rn,
              value: rn
            })) || []
          }
          onChange={(_, value) =>
            handleRequestNatureChange(value, original._id, original)
          }
          disabled={loading || refetching}
        />
      )
    },
    {
      Header: "Keywords",
      accessor: "projectKeywords",
      Cell: ({ original }) => (
        <TagInput
          name="keywords"
          placeholder="Type keyword and press enter..."
          values={original.projectKeywords || []}
          maxWidth="100%"
          onChange={(_, val, newName) => {
            const isNameEntryError = newName?.length === 0;
            if (newName === undefined || !isNameEntryError) {
              handleKeywordsChange(val, original._id, original);
            }
          }}
          disabled={loading || refetching}
        />
      )
    }
  ];

  if (data.count === 0 && !loading) {
    return (
      <div className="loading" style={{ textAlign: "center" }}>
        <h4 style={{ opacity: 0.15 }}>No Data</h4>
      </div>
    );
  }

  if (loading && !refetching) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Loading active={loading} />
      </div>
    );
  }

  return (
    <div className="content-wrapper" style={{ marginLeft: 0, marginRight: 0 }}>
      <ReactTable
        className="rt-project-keywords-customer-list"
        data={innerData}
        showPageSizeOptions={false}
        showPagination
        noDataText="No rows found"
        manual
        columns={columns}
        pageSize={Math.min(data.result.length, 20)}
        pages={Math.floor(data.count / 20)}
        page={page}
        onPageChange={onPageChange}
        expanded={expanded}
        onExpandedChange={(newExpanded, index) => handleRowToggle(index)}
        SubComponent={({ original }) => (
          <ReactTable
            className="rt-project-keywords-projects-list"
            data={original.projects}
            columns={projectColumns}
            showPagination={false}
            showPageSizeOptions={false}
            pageSize={original.projects.length}
            manual
          />
        )}
      />
    </div>
  );
};

ProjectKeywordsList.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  refetching: PropTypes.bool,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  onProjectChange: PropTypes.func
};

ProjectKeywordsList.defaultProps = {
  data: {
    result: [],
    count: 0
  }
};

function mapStatesToProps(state) {
  return {
    data: state.reducers.inProgressCustomerProjects,
    loading: state.reducers.loading,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ProjectKeywordsList);
